import { InjectionToken } from "@angular/core";

export const AUTO_LOGIN_CREDENTIALS = new InjectionToken(
  "AUTO_LOGIN_CREDENTIALS",
);
